export enum ROLES {
  CREATORS = 'CREATORS',
  ARTISTS = 'ARTISTS',
  ADMIN = 'ADMIN'
}
